function OnBoardingTabs({ tabs = [], activeTab = "", onTabChange }) {
  return (
    <div className="on-boarding-tabs" role="tablist" aria-label="On boarding sections">
      {tabs.map((tab) => {
        const isActive = tab.id === activeTab;
        const Icon = tab.Icon;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            className={`on-boarding-tab ${isActive ? "is-active" : ""}`}
            aria-selected={isActive}
            onClick={() => onTabChange?.(tab.id)}
          >
            <span className="on-boarding-tab-icon-wrap">
              <Icon size={22} />
            </span>
            <span className="on-boarding-tab-label">{tab.label}</span>
          </button>
        );
      })}
    </div>
  );
}

export default OnBoardingTabs;
